import React, { useCallback, useState } from 'react'
import { validationService } from '../utils/validation/forgotPasswordValidation'
import { forgotPasswordService } from '../services/forgotPasswordService'
import { enqueueSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'

const useForgotPassword = () => {
  const [errors, setErrors] = useState({})
  const [formData, setFormData] = useState({
    email: '',
    otp: '',
    password: '',
    confirmPassword: '',
  })

  const [sentOtp, setSentOtp] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [serverError, setServerError] = useState('') 

  const [generatedOtp, setGeneratedOtp] = useState('')

  const navigate = useNavigate()

  const [showPassword, setShowPassword] = useState({
    password1: false,
    password2: false,
  })

  const handleClickPasswordShowOff = (field) => {
    setShowPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }))
  }
  // pass sentOtp
  const validateForgotPass = useCallback(() => {
    const inputFieldError = validationService.forgotPasswordValidation(
      formData,
      sentOtp
    )
    setErrors(inputFieldError)

    return Object.keys(inputFieldError).length === 0
  }, [formData, sentOtp]) // sentOtp added dependency

  const onChange = useCallback((field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }))

    // clear the errors for specific fields
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: '' }))
    }
  })

  // verify OTP
  const verifyOTP = () => {
    if (!formData.otp || !generatedOtp) {
      setErrors((prev) => ({ ...prev, otp: 'Otp require' }))
      return false
    }
    if (formData.otp === generatedOtp) {
      return true
    } else {
      setErrors((prev) => ({
        ...prev,
        otp: 'Invalid OTP. Please check and try again.',
      }))
      return false
    }
  }

  const handleSubmit = useCallback(async () => {
    const isValid = validateForgotPass()
    if (!isValid) {
      console.log('Validation failed:', errors)
      return
    }
    setIsLoading(true)
    setServerError('') // clear previous errors
    try {
      if (!sentOtp) {
        const emailExist = await forgotPasswordService.checkExitsEmail(
          formData.email
        )
        if (!emailExist) {
          setServerError('Email does not exits')
          return
        }
        await forgotPasswordService.sendOtp(formData)
        enqueueSnackbar('Otp sent successfully', { variant: 'success' })

                
      } else {
        // STEP 2: Verify OTP and update password
        setIsLoading(true)
        
        const result = await forgotPasswordService.verifyOtpAndReset(formData)
        if(result.success){
            enqueueSnackbar("Password Reset Successfully", { variant: "success" })    
             navigate('/students-login')   
        }
        else {
          setIsLoading(false)
          setServerError("Failed to verify and reset password")
        }
    
       
      }
    } catch (error) {
      console.error('Error in forgot password:', error)
      setServerError(error.message || 'Something went wrong. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }, [validateForgotPass, errors, sentOtp, formData, generatedOtp, navigate])

  return {
    errors,
    formData,
    handleSubmit,
    onChange,
    sentOtp,
    isLoading,
    serverError,
    handleClickPasswordShowOff,
    showPassword,
    // enterOtp
  }
}
export { useForgotPassword }
